export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1"},{"name":"author","content":"Tauschwohnung.com - Tauschwohnung GmbH"},{"name":"description","content":"Jetzt Wohnung, Haus oder WG-Zimmer kostenfrei einstellen und sofort Wohnungstausch Partner aus über 50.821 Tauschwohnungen sehen für deinen Wohnungsswap."},{"name":"keywords","content":"wohnungstausch, haustausch, wohnungsswap, tausche haus, tauschwohnung, wohnungen tauschen, tausche wohnung, guenstige wohnung, mietwohnungen, wohnungen von privat, wohnungstauschbörse, wg-zimmer, wg"},{"name":"title","content":"Tauschwohnung.com - Tauschwohnung GmbH"},{"name":"facebook-domain-verification","content":"iefkofd3ayc1lnyvworeshvymbgb1a"},{"property":"og:title","content":"Dauerhafter Wohnungstausch - Tauschwohnung"},{"property":"og:type","content":"website"},{"property":"og:image","content":"https://www.tauschwohnung.com/assets/images/social/tauschwohnung_teilen.jpg"},{"property":"og:image:secure_url","content":"https://www.tauschwohnung.com/assets/images/social/tauschwohnung_teilen.jpg"},{"property":"og:site_name","content":"Tauschwohnung"},{"property":"og:description","content":"Jetzt Wohnung, Haus oder WG-Zimmer kostenfrei einstellen und sofort Wohnungstausch Partner aus über 50.821 Tauschwohnungen sehen für deinen Wohnungsswap."},{"property":"og:local","content":"de_DE"}],"link":[{"rel":"icon","type":"image/png","href":"/android-icon-36x36.png"},{"rel":"icon","type":"image/png","href":"/android-icon-48x48.png"},{"rel":"icon","type":"image/png","href":"/android-icon-72x72.png"},{"rel":"icon","type":"image/png","href":"/android-icon-96x96.png"},{"rel":"icon","type":"image/png","href":"/android-icon-144x144.png"},{"rel":"icon","type":"image/png","href":"/android-icon-192x192.png"},{"rel":"icon","type":"image/png","href":"/apple-icon.png"},{"rel":"icon","type":"image/png","href":"/apple-icon-57x57.png"},{"rel":"icon","type":"image/png","href":"/apple-icon-60x60.png"},{"rel":"icon","type":"image/png","href":"/apple-icon-72x72.png"},{"rel":"icon","type":"image/png","href":"/apple-icon-76x76.png"},{"rel":"icon","type":"image/png","href":"/apple-icon-114x114.png"},{"rel":"icon","type":"image/png","href":"/apple-icon-120x120.png"},{"rel":"icon","type":"image/png","href":"/apple-icon-144x144.png"},{"rel":"icon","type":"image/png","href":"/apple-icon-152x152.png"},{"rel":"icon","type":"image/png","href":"/apple-icon-180x180.png"},{"rel":"icon","type":"image/png","href":"/apple-icon-precomposed.png"},{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"icon","type":"image/png","href":"/favicon-16x16.png"},{"rel":"icon","type":"image/png","href":"/favicon-32x32.png"},{"rel":"icon","type":"image/png","href":"/favicon-96x96.png"},{"rel":"icon","type":"image/png","href":"/ms-icon-70x70.png"},{"rel":"icon","type":"image/png","href":"/ms-icon-144x144.png"},{"rel":"icon","type":"image/png","href":"/ms-icon-150x150.png"},{"rel":"icon","type":"image/png","href":"/ms-icon-310x310.png"},{"rel":"manifest","href":"/site.webmanifest"}],"style":[],"script":[],"noscript":[],"title":"Dauerhafter Wohnungstausch - Tauschwohnung"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false